var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-sortable",
    {
      attrs: { tag: "w-list", "target-class": "handle", items: _vm.items },
      on: {
        drop: function ($event) {
          return _vm.storeItems()
        },
      },
    },
    [
      _vm._l(_vm.items, function (col, i) {
        return _c(
          "w-list-item",
          { key: i, attrs: { "show-handle": "" } },
          [
            _c(
              "w-list-item-icon",
              [
                _c(
                  "w-link",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("toggle-subtract"),
                        expression: "$ct('toggle-subtract')",
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.toggleSubtract(col)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: _vm.getSubtractIcon(col) } })],
                  1
                ),
              ],
              1
            ),
            _c("w-list-item-text", [_vm._v(_vm._s(_vm.getColumnName(col)))]),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("remove-field"),
                        expression: "$ct('remove-field')",
                      },
                    ],
                    staticClass: "danger",
                    on: {
                      click: function ($event) {
                        return _vm.removeCol(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-list-item",
        {
          on: {
            click: function ($event) {
              return _vm.addColumnClicked()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("add-field")))]),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.addModalOpen,
            callback: function ($$v) {
              _vm.addModalOpen = $$v
            },
            expression: "addModalOpen",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("add-field")) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.close"),
                          expression: "$ct('common.close')",
                        },
                      ],
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.addModalOpen = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-content",
                [
                  _c("app-column-select", {
                    attrs: {
                      model: _vm.model,
                      "nummeric-only": "",
                      "is-filter": false,
                      browse: _vm.browse,
                      "is-server-column": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onColumnSelected($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }